<!--New UI designs-->

<app-app-loader *ngIf="isLoading"></app-app-loader>
<div class="analyticsPage new" #pageRoot [style.opacity]="isLoading ? 0 : 1">
    <div class="wrpr">
        <div class="contentCard new">
            <div class="pageHead">
                <div class="breadCrumbCont">
                     <a class="breadCrumbLink" 
                        routerLink="/analytics"
                        [ngClass]="{'active': router.url === '/analytics'}">
                        Analytics Home
                    </a>
                    <p>/</p>
                    <a class="breadCrumbLink" 
                        routerLink="/all-analytics"
                        [ngClass]="{'active': router.url === '/all-analytics'}">
                        All Analytics
                    </a>
                </div>
                <div class="contentCard">
                    <div class="flexSP" style="position: relative;">
                        <div class="tabSelectorCont">
                            <a class="tabItem" [class.active]="selectedTab() === 'All Dashboards'"
                                (click)="selectedTab.set('All Dashboards');selectedAnalyticsTab =('All Dashboards');onTabChange()">
                           <!-- <img class="blue dontShow" src="/assets/images/allDashboardsIcon-blue.svg" alt="" />
                                <img class="white dontShow" src="/assets/images/allDashboardsIcon-white.svg" alt="" /> -->
                                All Analytics <span>{{ allDashboardCount() }}</span>
                            </a>
                            <a *ngIf="userId && isUserLoggedIn" class="tabItem" [class.active]="selectedTab() === 'My Dashboards'"
                                (click)="selectedTab.set('My Dashboards');selectedAnalyticsTab = ('My Dashboards');onTabChange()">
                                <!-- <img class="blue dontShow" src="/assets/images/allDashboardsIcon-blue.svg" alt="" />
                                <img class="white dontShow" src="/assets/images/allDashboardsIcon-white.svg" alt="" /> -->
                                My Analytics <span>{{ myDashboardCount() }}</span>
                            </a>
                            <a *ngIf="userId && isUserLoggedIn" class="tabItem" [class.active]="selectedTab() === 'Bookmarks'"
                                (click)="selectedTab.set('Bookmarks');selectedAnalyticsTab =('Bookmarks');onTabChange()">
                                <!-- <img class="blue dontShow" *ngIf="selectedTab()"
                                    src="/assets/images/allDashboardsIcon-blue.svg" alt="" />
                                <img class="white dontShow" src="/assets/images/allDashboardsIcon-white.svg" alt="" /> -->
                                Bookmarks <span>{{ bookmarkedCount()}}</span>
                            </a>
                        </div>
                        <input type="search" style="padding-right: 2.5em;" class="search inputField" placeholder="Search Analytics" [(ngModel)]="searchText"
                            (keyup.enter)="filterAnalytics()" />
                        <button type="button" *ngIf="searchText" class="clear-btn" (click)="searchText=''; filterAnalytics()">
                            &#x2715;
                        </button>
                      </div>
                    <div class="filtersCont new" *ngIf="selectedTab() === 'All Dashboards'">
                            <div class="nameAndIcon"  (click)="toggleFiltersCont()">
                                <img src="/assets/images/newFiltersIcon.svg" alt="" />
                                <h4>
                                    Filters
                                    <span
                                        *ngIf="
                                            selectedRegions().length ||
                                            selectedBusinessLines().length ||
                                            selectedFunctions().length ||
                                            selectedProductLines().length ||
                                            selectedCategories().length"
                                        >
                                        (
                                        {{
                                            selectedRegions().length +
                                            selectedBusinessLines().length +
                                            selectedFunctions().length +
                                            selectedCategories().length+
                                            selectedProductLines().length
                                        }}
                                        selected)
                                    </span>
                                </h4>

                                <hr class="vertical" *ngIf="
                                    selectedRegions().length ||
                                    selectedBusinessLines().length ||
                                    selectedFunctions().length ||
                                    selectedProductLines().length ||
                                    selectedCategories().length">

                                <a (click)="resetAllFilters()" class="dmintLinkBtn red" style="margin-top: 5px; padding: 0;" *ngIf="
                                    selectedRegions().length ||
                                    selectedBusinessLines().length ||
                                    selectedFunctions().length ||
                                    selectedProductLines().length ||
                                    selectedCategories().length">
                                    Reset all
                                </a>
                            <img style="margin-left: auto;" class="" src="/assets/images/chevron-south.svg" alt=""/>
                            </div>
                            <div class="filtersBox"  *ngIf="isFilterOpen">
                                <form class="filtersBox" [formGroup]="filterForm">
                                    <div class="filterType">
                                        <label> Regions: </label>
                                        <div class="optionsSet">
                                            <label for="{{ region.regionName }}" class="optionBtn" [ngClass]="{ checked: selectedRegions().includes(region.regionName)}"  *ngFor="let region of allRegions" (click)="onRegionCheckboxChange($event, region, true)">
                                                <input type="checkbox" [checked]="selectedRegions().includes(region.regionName)"
                                                    id="{{ region }}"/>
                                                         {{ region.regionName }}
                                                <img src="/assets/images/users/closeIcon-16x16.svg" alt=""
                                                    *ngIf="selectedRegions().includes(region.regionName)" />
                                            </label>
                                        </div>
                                    </div>
                                    <div class="filterType">
                                        <label> Business Lines: </label>
                                        <div class="optionsSet">
                                            <label for="{{ businessLine.businessLineName }}" class="optionBtn" [ngClass]="{checked: selectedBusinessLines().includes(businessLine.businessLineName)}" *ngFor="let businessLine of allBusinessLines" (click)="onBusinessLinesCheckboxChange($event, businessLine, true)">
                                                <input type="checkbox" [checked]="selectedBusinessLines().includes(businessLine.businessLineName)"
                                                id="{{ businessLine }}"/>
                                                {{ businessLine.businessLineName }}
                                                <img src="/assets/images/users/closeIcon-16x16.svg" alt=""
                                                    *ngIf="selectedBusinessLines().includes(businessLine.businessLineName)" />
                                            </label>
                                        </div>
                                    </div>
                                      <div class="filterType">
                                        <label> Product Lines: </label>
                                        <div class="optionsSet">
                                            <label for="{{ productLine.productLineName }}" class="optionBtn" [ngClass]="{checked: selectedProductLines().includes(productLine.productLineName)}"
                                             *ngFor="let productLine of allProductLines" (click)="onProductLinesCheckboxChange($event, productLine, true)">
                                                <input type="checkbox"
                                                [checked]="selectedProductLines().includes(productLine.productLineName)"
                                                id="{{ productLine }}"/>
                                                {{ productLine.productLineName }}
                                                <img src="/assets/images/users/closeIcon-16x16.svg" alt=""
                                                    *ngIf="selectedProductLines().includes(productLine.productLineName)" />
                                            </label>
                                        </div>
                                    </div>
                                    <div class="filterType">
                                        <label> Functions: </label>
                                        <div class="optionsSet">
                                            <label for="{{ function.functionName }}" class="optionBtn" [ngClass]="{
                            checked: selectedFunctions().includes(function.functionName)
                        }" *ngFor="let function of allFunctions" (click)="onFunctionsCheckboxChange($event, function, true)">
                                                <input type="checkbox"
                                                [checked]="selectedFunctions().includes(function.functionName)"
                                                    id="{{ function }}" />
                                                {{ function.functionName }}
                                                <img src="/assets/images/users/closeIcon-16x16.svg" alt=""
                                                    *ngIf="selectedFunctions().includes(function.functionName)" />
                                            </label>
                                        </div>
                                    </div>
                                    <div class="filterType">
                                        <label for="regions"> Categories: </label>
                                        <div class="optionsSet">
                                            <label for="{{ category.categoryName }}" class="optionBtn" [ngClass]="{checked: selectedCategories().includes(category.categoryName)}"
                                             *ngFor="let category of allCategories" (click)="onCategoryCheckboxChange($event, category, true)" >
                                                <input type="checkbox"  (change)="onCategoryCheckboxChange($event, category)"
                                                    [checked]="selectedCategories().includes(category.categoryName)" />
                                                {{ category.categoryName }}
                                                <img src="/assets/images/users/closeIcon-16x16.svg" alt="" *ngIf="
                                                selectedCategories().includes(category.categoryName)
                                                " />
                                            </label>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        
                    </div>
                    <div class="tabContent">
                        <div class="appliedFilters flexSP justStart" *ngIf="selectedRegions().length || selectedBusinessLines().length || selectedFunctions().length || selectedProductLines().length || selectedCategories().length" >
                            <h4>Applied Filters:</h4>
                            <div class="filterTag" *ngFor="let region of selectedRegions()">
                                {{ region }}
                                <img style="cursor: pointer;"(click)="onRegionCheckboxChange($event, region, true)" src="/assets/images/users/closeIcon-16x16.svg" alt="" />
                            </div>
                            <div class="filterTag" *ngFor="let businessLine of selectedBusinessLines()">
                                {{ businessLine }}
                                <img style="cursor: pointer;"(click)="onBusinessLinesCheckboxChange($event, businessLine, true)" src="/assets/images/users/closeIcon-16x16.svg" alt="" />
                            </div>
                            <div class="filterTag" *ngFor="let function of selectedFunctions()">
                                {{ function }}
                                <img style="cursor: pointer;" (click)="onFunctionsCheckboxChange($event, function, true)" src="/assets/images/users/closeIcon-16x16.svg" alt="" />
                            </div>
                            <div class="filterTag" *ngFor="let category of selectedCategories()">
                                {{ category }}
                                <img style="cursor: pointer;" (click)="onCategoryCheckboxChange($event, category, true)"  src="/assets/images/users/closeIcon-16x16.svg" alt="" />
                            </div>
                                <div class="filterTag" *ngFor="let productLine of selectedProductLines()">
                                {{ productLine }}
                                <img style="cursor: pointer;" (click)="onProductLinesCheckboxChange($event, productLine, true)" src="/assets/images/users/closeIcon-16x16.svg" alt="" />
                            </div>
                        </div>
                        <div class="flexSP" style="margin-bottom: -8px; margin-top: 16px;">
                            <p class="flexSP itemCount">
                                Showing {{ filterDashboard()?.length }} analytics
                            </p>
                            <div class="formControl sort new" *ngIf="selectedTab() === 'All Dashboards'">
                                <p>
                                    <span>
                                        <img src="/assets/images/sort.svg" alt="" style="margin-bottom: 4px; margin-right: 4px;"/>
                                    </span>
                                    Sort By
                                </p>
                                <button class="toggleCont new" (click)="showSorting()">
                                    <span *ngIf="!selectedSort" class="optionSelected">Newly Added</span>
                                    <span *ngIf="selectedSort" class="optionSelected">{{selectedSort}}</span>
                                    <img src="/assets/images/chevron-south.svg" alt="chevron-south" />
                                </button>
                                <div class="optionsCont" *ngIf="isSortingOpen">
                                    <button *ngFor="let item of sortingList" class="option"
                                        (click)="sortAnalytics(item)">
                                        {{ item.label }}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="products">
                            <div class="noResults" *ngIf="analyticsProducts?.length == 0">
                                <img src="/assets/images/noResults.png" alt="no-results" />
                                <p>No results found.</p>
                            </div>
                            <div class="productCard" *ngFor="let analyticsProduct of filterDashboard()">
                                <div class="productCardContent">
                                    <div class="banner" [ngClass]="{ dataSet: analyticsProduct.isDashboard! }">
                                        <img [src]="(moduleByteMap[analyticsProduct.moduleName]) | base64: 'image/png'"
                                            alt="power-bi-dashboards-icon" />
                                    </div>
                                    <div class="tag new" *ngIf="analyticsProduct.newlyAdded">
                                    Newly Added
                                    </div>
                                    <div class="h2">
                                        <h2>
                                            {{ analyticsProduct.moduleName }}
                                        </h2>
                                        <div class="iconBtn" *ngIf="userId">
                                            <input *ngIf="analyticsProduct.favorite" type="checkbox"
                                                [(ngModel)]="analyticsProduct.favorite" class="hidden-checkbox" />
                                            <img class="addToBook"
                                             (click)="toggleFavourite(analyticsProduct)"
                                             [src]="analyticsProduct.favorite
                                                    ? '../../../../assets/images/bookmarksIcon-filled.svg'
                                                    : '../../../../assets/images/bookmarksIcon.svg'"
                                             alt=""
                                             />
                                        </div>
                                    </div>
                                    <p class="desc">
                                        {{ analyticsProduct.moduleShortDescription }}
                                    </p>
                                    <div class="staticTags" *ngIf="analyticsProduct.tags && analyticsProduct.tags.length > 0">
                                        <div class="tag" *ngFor="let tag of analyticsProduct.tags | slice:0:4">
                                             {{ $any(tag).tagName }}
                                        </div>
                                        <div class="tag more" *ngIf="analyticsProduct.tags.length > 4">
                                            +{{ analyticsProduct.tags.length - 4 }}
                                        </div>
                                    </div>
                                </div>
                                <div class="twoBtns">
                                    <button class="secondary" *ngIf="!userId && !isUserLoggedIn"
                                       (click)="onSignIn()">
                                       <img src="/assets/images/locked.svg" alt="" style="width: 16px; margin-top: -4px;">
                                       <!-- previously knows as Sign IN -->
                                         Request Access
                                    </button>                                   
                                    <button class="primary" *ngIf="analyticsProduct.subscription && userId && isUserLoggedIn" (click)="loadModule(analyticsProduct)">
                                         <!-- previously knows as Visit Sight -->
                                        Open Analytics
                                    </button>
                                  
                                    <button class="secondary"
                                        *ngIf="analyticsProduct.subscription == false&& analyticsProduct.accessCompleted == undefined &&userId &&isUserLoggedIn"
                                        (click)="onRequestAccessClick(analyticsProduct)">
                                        <img src="/assets/images/locked.svg" alt="" style="width: 16px; margin-top: -4px;"/>
                                        Request Access
                                    </button>
                                  
                                    <button class="secondary"
                                        *ngIf="analyticsProduct.subscription == false&& analyticsProduct.accessCompleted != undefined && analyticsProduct.accessCompleted == false && userId &&isUserLoggedIn"
                                        (click)="onAccessPending()">
                                        <img src="/assets/images/locked.svg" alt="" />
                                        Access Pending
                                    </button>
                                    
                                    <button class="dmintLinkBtn" 
                                        (click)="viewDetails(analyticsProduct)" 
                                        style="margin-bottom: 
                                        -2px !important;">
                                        View Details
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-success-toast [message]="successMessage" *ngIf="successMessage"></app-success-toast>

<app-alert [message]="errMsg" *ngIf="showErrorMessageWithPopup" (close)="onCloseHandlerSub()"></app-alert>